export default __webpack_public_path__ + "static/media/joe.261df02c.webp";